module.exports = __webpack_public_path__ + "img/assuraf.23e7b04c.png";